import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"

import useSortData from './useSortData';


export default function useOperators(props, emit, operatorData) {

    // Get toast interface
    const toast = useToast()

    const operatorStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })


    const getOperators = (url = null) => {
        store.dispatch("getOperators", {
            url,
            search: search.value,
            status: operatorStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true
        if (operatorData.value.id) {
            store.dispatch('updateOperator', operatorData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("اپراتور مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getOperators")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createOperator", operatorData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success(" اپراتور مورد نظر با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getOperators")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const changePasswordOperator = () => {
        loading.value = true
        if (operatorData.value.id) {
            store.dispatch('changePasswordOperator', operatorData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("کلمه عبور اپراتور مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getOperators")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })

        }
    }


    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getOperators);

    const sortOperators = (field) => {
        sortData(field);
        getOperators();
    };


    return {
        show,
        operatorStatus,
        search,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getOperators,
        onSubmit,
        changePasswordOperator,
        closeModal,
        sortOperators,
    }
}